document.addEventListener('DOMContentLoaded', ()=>{
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const header = document.querySelector('.section-header');

    let swiperInstance = null;
    function initOrDestroySwiper() {
        const mediaEl = document.querySelector('.media__exceution_swiper.swiper');
        if (!mediaEl) return;
        const isMobile = window.innerWidth < 750;
        if (isMobile && !swiperInstance) {
            const mediaConfig = {spaceBetween:0,slidesPerView:1.05,pagination:{el:'.swiper-pagination',type:'progressbar'} };
            swiperInstance = new Swiper(mediaEl, mediaConfig);
        }
        if (!isMobile && swiperInstance) { swiperInstance.destroy(true, true); swiperInstance = null; }
    }
    initOrDestroySwiper(); 
    window.addEventListener('resize', function(event) { initOrDestroySwiper() }, true);

    const testimonialEl = document.querySelector('.Testimonial__reviews_interior.swiper');
    if (testimonialEl) {
        const testimonialConfig = { spaceBetween: 12, slidesPerView: 'auto', grabCursor: true };
        if (!isIOS) {
            testimonialConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
            testimonialConfig.freeMode = true;
        }
        new Swiper(testimonialEl, testimonialConfig);
    } 

    const swiperElements = document.querySelectorAll('.iconText_highPricePoint_swipe.swiper');
    if (swiperElements.length > 0) {
        swiperElements.forEach((elm, index) => {
            const config = { spaceBetween: 12, slidesPerView: 'auto', allowTouchMove: true, grabCursor: true, };
            if (!isIOS) { config.mousewheel = { forceToAxis: true, thresholdDelta: 35 }; config.freeMode = true; }
            new Swiper(elm, config);
        });
    }    

    const getGuid = ()=> {
        let d = new Date().getTime();
        let d2 =  (performance && performance.now && (performance.now() * 1000)) || 0;
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            let r = Math.random() * 16;
            if (d > 0) {
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c == 'x' ? r: (r & 0x7 | 0x8)).toString(16);
        }); 
    }    

    document.querySelectorAll('[data-section-type="page-lp-cyb-v"]').forEach(initTwoByTwoPricing);
 
    function initTwoByTwoPricing(root) {
        const priceEls = root.querySelectorAll('[js-price-total-proceed]');
        const comparePriceEls = root.querySelectorAll('[js-compare-price-total-proceed]');
        if (!priceEls.length && !comparePriceEls.length) return;
        let currencySymbol = '$';
 
        function parsePrice(raw) {
            if (!raw) return 0;
            const str = raw.toString().trim();
            const symbolMatch = str.match(/^[^\d.,-]+/);
            if (symbolMatch) currencySymbol = symbolMatch[0];
            const num = parseFloat(str.replace(/[^0-9.]/g, ''));
            return isNaN(num) ? 0 : num;
        }
 
        function formatPrice(num) {
            return currencySymbol + num.toFixed(2);
        }
 
        function formatPriceAsCents(num) {
            return Math.round(num * 100).toString();
        }
 
        function updateBundleJson(selectedBase, subPrice, subComparePrice, totalPrice, totalComparePrice) {
            if (!selectedBase) return;
            const jsonScript = root.querySelector('cus-variants-single-two .bundle-data-json');
            if (!jsonScript) {
                return;
            }
 
            let bundleData;
            try {
                bundleData = JSON.parse(jsonScript.textContent);
            } catch (err) {
                return;
            }
 
            let groupKey = selectedBase.value;
 
            if (!bundleData[groupKey]) {
                const allBaseRadios = Array.from(root.querySelectorAll('input[name="base__option"]'));
                const index = allBaseRadios.indexOf(selectedBase);
                const fallbackKey = 'bundle_group_' + index;
                if (!bundleData[fallbackKey]) {
                    return;
                }
                groupKey = fallbackKey;
            }
 
            bundleData[groupKey].custom_sub_price = formatPriceAsCents(totalPrice);
            bundleData[groupKey].custom_sub_compare_price = formatPriceAsCents(totalComparePrice);
            bundleData[groupKey].custom_price = formatPriceAsCents(totalComparePrice);
            // bundleData[groupKey].custom_compare_price = formatPriceAsCents(totalComparePrice);
            jsonScript.textContent = JSON.stringify(bundleData, null, 4);
        }

        function getGiftWrapperQty(wrapper) {
            const outer = wrapper.querySelector('[js-button-confiq-outer]');
            if (!outer || !outer.classList.contains('active')) return 0;
            const qtyInput = wrapper.querySelector('[js-button-confiq-input]');
            const qty = qtyInput ? parseInt(qtyInput.textContent, 10) : 1;
            return Number.isFinite(qty) && qty > 0 ? qty : 1;
        }

        function setGiftWrapperQty(wrapper, qty) {
            const qtyInput = wrapper.querySelector('[js-button-confiq-input]');
            if (qtyInput) qtyInput.textContent = qty.toString();

            const removeBtn = wrapper.querySelector('[js-button-confiq-remove]');
            const minusBtn = wrapper.querySelector('[js-button-confiq-minus]');
            if (qty <= 1) {
                removeBtn?.classList.remove('hidden');
                minusBtn?.classList.add('hidden');
            } else {
                removeBtn?.classList.add('hidden');
                minusBtn?.classList.remove('hidden');
            }
        }

        function activateGiftWrapper(wrapper) {
            const outer = wrapper.querySelector('[js-button-confiq-outer]');
            outer?.classList.add('active');
            setGiftWrapperQty(wrapper, 1);
        }

        function deactivateGiftWrapper(wrapper) {
            const outer = wrapper.querySelector('[js-button-confiq-outer]');
            outer?.classList.remove('active');
            setGiftWrapperQty(wrapper, 1);
        }

        function getActiveGiftWrappers() {
            return Array.from(root.querySelectorAll('[js-unlock-gifts-option]')).filter((wrapper) => getGiftWrapperQty(wrapper) > 0);
        }

        function syncPausedGiftOptions(selectedBase) {
            const baseTitle = selectedBase ? selectedBase.dataset.baseTitle : null;
            root.querySelectorAll('[js-unlock-gifts-option]').forEach((wrapper) => {
                const unlockTitle = wrapper.dataset.unlockTitle;
                const isMatch = !!baseTitle && !!unlockTitle && baseTitle === unlockTitle;
                wrapper.classList.toggle('paused_option', isMatch);
                if (isMatch) {
                    deactivateGiftWrapper(wrapper);
                }
            });
        }

        function updateFreeGiftsProgress() {
            const freeGiftEls = Array.from(root.querySelectorAll('[js-free-gifts-avail]'));
            const totalFreeGifts = freeGiftEls.length;
            if (!totalFreeGifts) return;
            const textEl = root.querySelector('[js-text-based-on-free-gifts]');
            const barEl = root.querySelector('[js-based-on-free-gifts-bar]');
            const headerEl = root.querySelector('[js-unlock-gifts-header]');
            const totalActiveQty = getActiveGiftWrappers().reduce((sum, wrapper) => sum + getGiftWrapperQty(wrapper), 0);

            freeGiftEls.forEach((giftEl, index) => {
                const isUnlocked = index < totalActiveQty;
                giftEl.classList.toggle('paused_option', !isUnlocked);
            });
 
            const progressPercent = Math.min(100, Math.round((totalActiveQty / totalFreeGifts) * 100));
            if (barEl) barEl.style.width = progressPercent + '%';

            if (headerEl) {
                headerEl.textContent = totalActiveQty >= totalFreeGifts ? 'Keep adding for additional support!' : 'Add more drops to unlock free gifts!';
            }

            if (textEl) {
                const unlockedValue = freeGiftEls.slice(0, totalActiveQty).reduce((sum, giftEl) => sum + parsePrice(giftEl.dataset.freeValue), 0);
                const unlockedValueText = 'You’ve unlocked ' + formatPrice(unlockedValue) + ' in free gifts';
                if (totalActiveQty >= totalFreeGifts) {
                    textEl.textContent = '✓ You’ve unlocked all gifts! Add more drops or checkout.';
                } else {
                    const nextGiftEl = freeGiftEls[totalActiveQty];
                    const nextGiftTitle = nextGiftEl ? nextGiftEl.dataset.freeTitle : '';
                    if (totalActiveQty === 0) {
                        textEl.textContent = 'Add one drop to Unlock ' + nextGiftTitle;
                    } else if (unlockedValue > 0) {
                        textEl.textContent = unlockedValueText + '! Add one more drop to Unlock ' + nextGiftTitle;
                    } else {
                        textEl.textContent = 'Add one more drop to Unlock ' + nextGiftTitle;
                    }
                }
            }
        }
 
        function calculateTotals() {
            let subPrice = 0;
            let subComparePrice = 0;
            let totalPrice = 0;
            let totalComparePrice = 0;
            const selectedBase = root.querySelector('input[name="base__option"]:checked');
            if (selectedBase) {
                subPrice = parsePrice(selectedBase.dataset.price);
                subComparePrice = parsePrice(selectedBase.dataset.comparePrice);
            }
 
            totalPrice = subPrice;
            totalComparePrice = subComparePrice;
            syncPausedGiftOptions(selectedBase);

            getActiveGiftWrappers().forEach((wrapper) => {
                const qty = getGiftWrapperQty(wrapper);
                const giftPrice = parsePrice(wrapper.dataset.price);
                const giftComparePrice = parsePrice(wrapper.dataset.comparePrice);
                totalPrice += giftPrice * qty;
                totalComparePrice += giftComparePrice * qty;
            });
 
            priceEls.forEach((el) => { el.textContent = formatPrice(totalPrice); });
            comparePriceEls.forEach((el) => { el.textContent = formatPrice(totalComparePrice); });

            if( document?.querySelectorAll(`[js-update-prices-text]`).length > 0 ){
                document?.querySelectorAll(`[js-update-prices-text]`).forEach((el)=>{
                    let currentTextBar = el.dataset.text;
                    el.innerHTML = `${currentTextBar} —&nbsp;${formatPrice(totalPrice)}&nbsp;<s>${formatPrice(totalComparePrice)}</s>`;
                })
            }
 
            updateFreeGiftsProgress();
            updateBundleJson(selectedBase, subPrice, subComparePrice, totalPrice, totalComparePrice);
        }
 
        root.addEventListener('change', function (e) {
            if (e.target.matches('input[name="base__option"]')) {
                calculateTotals();
            }
        });

        root.addEventListener('click', function (e) {
            const wrapper = e.target.closest('[js-unlock-gifts-option]');
            if (!wrapper) return;
            if (wrapper.classList.contains('paused_option')) return;
            if (e.target.closest('[js-button-confiq-add]')) {
                e.preventDefault();
                activateGiftWrapper(wrapper);
                calculateTotals();
                return;
            }

            if (e.target.closest('[js-button-confiq-plus]')) {
                e.preventDefault();
                const currentQty = getGiftWrapperQty(wrapper) || 1;
                setGiftWrapperQty(wrapper, currentQty + 1);
                calculateTotals();
                return;
            }

            if (e.target.closest('[js-button-confiq-minus]')) {
                e.preventDefault();
                const currentQty = getGiftWrapperQty(wrapper) || 1;
                setGiftWrapperQty(wrapper, Math.max(1, currentQty - 1));
                calculateTotals();
                return;
            }

            if (e.target.closest('[js-button-confiq-remove]')) {
                e.preventDefault();
                deactivateGiftWrapper(wrapper);
                calculateTotals();
                return;
            }
        });
 
        calculateTotals();
    }

    if (document.querySelectorAll('[js-subscribe-processing-cart]').length > 0) {
        const subscribeIdMap = {};
        let subscribeBoxIndexCounter = 0;
 
        function toSafeSellingPlanId(rawValue) {
            if (rawValue === null || rawValue === undefined || rawValue === '') return null;
            const num = Number(rawValue);
            if (!Number.isFinite(num)) return null;
            return Math.trunc(num);
        }
 
        document.querySelectorAll('[js-subscribe-processing-cart]').forEach((elm) => {
            elm.addEventListener('click', (event) => {
                event.preventDefault();
                const Etarget = event.currentTarget;
                const sectionRoot = Etarget.closest('[data-section-type="page-lp-cyb-v"]');
                if (!sectionRoot) return;
                const submitButton = Etarget.closest('.single_tw_o__content__bt__button')?.querySelector('button');
                if (submitButton) {
                    submitButton.classList.add('loading');
                    submitButton.disabled = true;
                }
                const cartElement = document.querySelector('cart-drawer');
                if (cartElement) cartElement.enableLoading();
                let itemsToAdd = [];
 
                const uniqID = new Date().getTime().toString();
                const bundleID = getGuid();
                const jsonScript = sectionRoot.querySelector('cus-variants-single-two .bundle-data-json');
                let bundleJson = {};
                try {
                    bundleJson = jsonScript ? JSON.parse(jsonScript.textContent) : {};
                } catch (err) {
                    console.error('[cyb-2x2] bundle-data-json parse error, add-to-cart abort:', err);
                }
 
                const selectedBase = sectionRoot.querySelector('input[name="base__option"]:checked');
                let groupKey = selectedBase ? selectedBase.value : null;
 
                if (groupKey && !bundleJson[groupKey]) {
                    const allBaseRadios = Array.from(sectionRoot.querySelectorAll('input[name="base__option"]'));
                    const index = allBaseRadios.indexOf(selectedBase);
                    const fallbackKey = 'bundle_group_' + index;
                    groupKey = fallbackKey;
                }
 
                const data = groupKey ? bundleJson[groupKey] : null;
 
                if (data && data.ids) {
                    let dynamicBoxID = data.dynbox,
                        dynamicBoxIndex = 0,
                        lineQty = data.custom_quantity,
                        servingInCart = data.custom_servings,
                        customImage = data.custom_image,
                        customProductTitle = data.product_title || 'Custom Care Kit';
 
                    if (bundleID && bundleID.toString().trim() !== '') {
                        const trimmedBundleID = bundleID.toString().trim();
                        if (subscribeIdMap[trimmedBundleID] === undefined) {
                            subscribeIdMap[trimmedBundleID] = subscribeBoxIndexCounter;
                            subscribeBoxIndexCounter++;
                        }
                        dynamicBoxIndex = subscribeIdMap[trimmedBundleID];
                    }
 
                    const idArray = typeof data.ids === 'string' ? data.ids.split(',') : (data.ids || []).slice();
                    const planArray = typeof data.plans === 'string' ? data.plans.split(',') : (data.plans || []).slice();
                    const qtyArray = typeof data.qtys === 'string' ? data.qtys.split(',') : (data.qtys || []).slice();
 
                    sectionRoot.querySelectorAll('[js-unlock-gifts-option]').forEach((giftWrapper) => {
                        const giftOuter = giftWrapper.querySelector('[js-button-confiq-outer]');
                        if (!giftOuter || !giftOuter.classList.contains('active')) return;

                        const giftVariantId = giftWrapper.dataset.variantId;
                        if (!giftVariantId || giftVariantId.toString().trim() === '') {
                            return;
                        }

                        const giftQtyInput = giftWrapper.querySelector('[js-button-confiq-input]');
                        const giftQtyRaw = giftQtyInput ? parseInt(giftQtyInput.textContent, 10) : 1;
                        const giftQty = Number.isFinite(giftQtyRaw) && giftQtyRaw > 0 ? giftQtyRaw : 1;

                        for (let i = 0; i < giftQty; i++) {
                            idArray.push(giftVariantId.toString().trim());
                            planArray.push(giftWrapper.dataset.sellingPlanId || '');
                            qtyArray.push('1');
                        }
                    });
 
                    const customQuantityGroup = qtyArray.join(',');
                    const mainProperties = {
                        _dynamicBoxId: dynamicBoxID,
                        _dynamicBoxIndex: dynamicBoxIndex,
                        _original_qty: lineQty,
                        _bundle_id: bundleID,
                        _is_byob_child: "true",
                        _is_onetime:"false",
                        _custom_image: customImage,
                        _custom_product_title: customProductTitle
                    };
 
                    itemsToAdd = idArray.map((id, index) => {
                        const itemBaseQty = parseInt(qtyArray[index]) || 1;
                        const itemProperties = {
                            ...mainProperties,
                            _uniq_id_lookup:uniqID
                        };
                        const item = {
                            id: id.toString().trim(),
                            quantity: itemBaseQty,
                            properties: itemProperties
                        };
                        if (planArray[index] && planArray[index] !== '') {
                            const safePlanId = toSafeSellingPlanId(planArray[index]);
                            if (safePlanId !== null) {
                                item.selling_plan = safePlanId;
                            }
                        }
                        return item;
                    });
                }
 
                if (!itemsToAdd.length) {
                    if (submitButton) {
                        submitButton.classList.remove('loading');
                        submitButton.disabled = false;
                    }
                    if (cartElement) cartElement.disableLoading();
                    return;
                }
 
                const productShouldBe = {
                    items: itemsToAdd,
                    sections: cartElement ? cartElement.getSectionsToRender().map((section) => section.section) : [],
                    sections_url: window.location.pathname
                };
 
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify(productShouldBe),
                    credentials: 'same-origin'
                })
                    .then(async (response) => {
                        const data = await response.json();
                        if (!response.ok) {
                            console.error('Shopify Cart Error Response:', data);
                            throw new Error(data.description || data.message || 'Failed to add items to cart (409 Conflict)');
                        }
                        return data;
                    })
                    .then((parsedState) => {
                        if (cartElement) cartElement.renderContent(parsedState.sections);
                    })
                    .catch((e) => console.error(e))
                    .finally(() => {
                        if (cartElement) {
                            cartElement.disableLoading();
                            cartElement.open();
                            document.querySelector('.cart_drawers__cross')?.setAttribute('role', 'button');
                            document.querySelector('.cart_drawers__cross')?.setAttribute('tabindex', '0');
                        }
                        if (submitButton) {
                            submitButton.classList.remove('loading');
                            submitButton.disabled = false;
                        }
                    });
            });
        });
    }

    if (document.querySelectorAll('[js-onetime-processing-cart]').length > 0) {
        const onetimeIdMap = {};
        let onetimeBoxIndexCounter = 0;
 
        document.querySelectorAll('[js-onetime-processing-cart]').forEach((elm) => {
            elm.addEventListener('click', (event) => {
                event.preventDefault();
 
                const Etarget = event.currentTarget;
                const sectionRoot = Etarget.closest('[data-section-type="page-lp-cyb-v"]');
                if (!sectionRoot) return;
 
                const submitButton = Etarget.closest('.single_tw_o__content__bt__button_ot')?.querySelector('button');
                if (submitButton) {
                    submitButton.classList.add('loading');
                    submitButton.disabled = true;
                }
 
                const cartElement = document.querySelector('cart-drawer');
                if (cartElement) cartElement.enableLoading();
                let itemsToAdd = [];
                const uniqID = new Date().getTime().toString();
                const bundleID = getGuid();

                const jsonScript = sectionRoot.querySelector('cus-variants-single-two .bundle-data-json');
                let bundleJson = {};
                try {
                    bundleJson = jsonScript ? JSON.parse(jsonScript.textContent) : {};
                } catch (err) {
                    console.error('[cyb-2x2] bundle-data-json parse error, one-time add-to-cart abort:', err);
                }
 
                const selectedBase = sectionRoot.querySelector('input[name="base__option"]:checked');
                let groupKey = selectedBase ? selectedBase.value : null;
 
                if (groupKey && !bundleJson[groupKey]) {
                    const allBaseRadios = Array.from(sectionRoot.querySelectorAll('input[name="base__option"]'));
                    const index = allBaseRadios.indexOf(selectedBase);
                    const fallbackKey = 'bundle_group_' + index;
                    groupKey = fallbackKey;
                }
 
                const data = groupKey ? bundleJson[groupKey] : null;
 
                if (data && data.ids) {

                    let dynamicBoxID = data.dynbox,
                        dynamicBoxIndex = 0,
                        lineQty = data.custom_quantity,
                        servingInCart = data.custom_servings,
                        customImage = data.custom_image,
                        customProductTitle = data.product_title || 'Custom Care Kit';
 
                    if (bundleID && bundleID.toString().trim() !== '') {
                        const trimmedBundleID = bundleID.toString().trim();
                        if (onetimeIdMap[trimmedBundleID] === undefined) {
                            onetimeIdMap[trimmedBundleID] = onetimeBoxIndexCounter;
                            onetimeBoxIndexCounter++;
                        }
                        dynamicBoxIndex = onetimeIdMap[trimmedBundleID];
                    }
 
                    const idArray = typeof data.ids === 'string' ? data.ids.split(',') : (data.ids || []).slice();
                    const planArray = typeof data.plans === 'string' ? data.plans.split(',') : (data.plans || []).slice();
                    const qtyArray = typeof data.qtys === 'string' ? data.qtys.split(',') : (data.qtys || []).slice();
 
                    sectionRoot.querySelectorAll('[js-unlock-gifts-option]').forEach((giftWrapper) => {
                        const giftOuter = giftWrapper.querySelector('[js-button-confiq-outer]');
                        if (!giftOuter || !giftOuter.classList.contains('active')) return;

                        const giftVariantId = giftWrapper.dataset.variantId;
                        if (!giftVariantId || giftVariantId.toString().trim() === '') {
                            return;
                        }

                        const giftQtyInput = giftWrapper.querySelector('[js-button-confiq-input]');
                        const giftQtyRaw = giftQtyInput ? parseInt(giftQtyInput.textContent, 10) : 1;
                        const giftQty = Number.isFinite(giftQtyRaw) && giftQtyRaw > 0 ? giftQtyRaw : 1;

                        for (let i = 0; i < giftQty; i++) {
                            idArray.push(giftVariantId.toString().trim());
                            planArray.push(giftWrapper.dataset.sellingPlanId || '');
                            qtyArray.push('1');
                        }
                    });
 
                    const customQuantityGroup = qtyArray.join(',');
                    const mainProperties = {
                        _dynamicBoxId: dynamicBoxID,
                        _dynamicBoxIndex: dynamicBoxIndex,
                        _original_qty: lineQty,
                        _bundle_id: bundleID,
                        _is_byob_child: "true",
                        _is_onetime:"true",
                        _custom_image: customImage,
                        _custom_product_title: customProductTitle                        
                    };
 
                    itemsToAdd = idArray.map((id, index) => {
                        const itemBaseQty = parseInt(qtyArray[index]) || 1;
                        const itemProperties = {
                            ...mainProperties,
                            _uniq_id_lookup:uniqID
                        };
 
                        const safePlanId = toSafeSellingPlanId(planArray[index]);
                        if (safePlanId !== null) {
                            itemProperties._selling_plan_id = safePlanId;
                        }
 
                        return {
                            id: id.toString().trim(),
                            quantity: itemBaseQty,
                            properties: itemProperties
                        };
                    });
                }
 
                if (!itemsToAdd.length) {
                    if (submitButton) {
                        submitButton.classList.remove('loading');
                        submitButton.disabled = false;
                    }
                    if (cartElement) cartElement.disableLoading();
                    return;
                }
 
                const productShouldBe = {
                    items: itemsToAdd,
                    sections: cartElement ? cartElement.getSectionsToRender().map((section) => section.section) : [],
                    sections_url: window.location.pathname
                };
 
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify(productShouldBe),
                    credentials: 'same-origin'
                })
                .then(async (response) => {
                    const data = await response.json();
                    if (!response.ok) {
                        console.error('Shopify Cart Error Response:', data);
                        throw new Error(data.description || data.message || 'Failed to add items to cart (409 Conflict)');
                    }
                    return data;
                })
                .then((parsedState) => {
                    if (cartElement) cartElement.renderContent(parsedState.sections);
                })
                .catch((e) => console.error(e))
                .finally(() => {
                    if (cartElement) {
                        cartElement.disableLoading();
                        cartElement.open();
                        document.querySelector('.cart_drawers__cross')?.setAttribute('role', 'button');
                        document.querySelector('.cart_drawers__cross')?.setAttribute('tabindex', '0');
                    }
                    if (submitButton) {
                        submitButton.classList.remove('loading');
                        submitButton.disabled = false;
                    }
                });
            });
        });
    }
    
    if( document.querySelectorAll('.video__playIcon').length > 0 ){
        document.querySelectorAll('.video__playIcon .action--pause').forEach((elm)=>{
            elm.addEventListener('click', (target)=>{
                target.preventDefault();
                target.currentTarget.classList.add('hidden');
                target.target.closest('.Testimonial__video_tagged').querySelector('.action--play').classList.remove('hidden');
                target.target.closest('.Testimonial__video_tagged').querySelector('video').pause();
            })
        });
        document.querySelectorAll('.video__playIcon .action--play').forEach((elm)=>{
            elm.addEventListener('click', (target)=>{
                target.preventDefault();
                target.currentTarget.classList.add('hidden');
                target.target.closest('.Testimonial__video_tagged').querySelector('.action--pause').classList.remove('hidden');
                target.target.closest('.Testimonial__video_tagged').querySelector('video').play();
            })
        });  
    }

    if( document.querySelectorAll('[js-doctor-dietitian-lightbox]').length > 0 ){
        document.querySelectorAll('[js-doctor-dietitian-lightbox]').forEach((elm)=>{
            elm.addEventListener('click',(target)=>{
                target.preventDefault();
                let lighhtbox_doctor = document.querySelector('.doctor_dietitian_lightbox_html').innerHTML;
                document.querySelector('.doctor_dietitian_lightbox').innerHTML = lighhtbox_doctor;
                document.querySelector('.doctor_dietitian_lightbox').classList.add('active');
                document.querySelector('.page-overlay').classList.add('is-visible');
                document.body.classList.add('overflow-hidden');
            })
        })   
    }
    
    class doctorDietitian extends HTMLElement{
        constructor(){
        super();
            this.querySelectorAll('[js-doctor-dietitian-lightbox-close]').forEach((elm)=>{
                elm.addEventListener('click',(target)=>{
                    target.preventDefault();
                    document.querySelector('.doctor_dietitian_lightbox').innerHTML = ``;
                    document.querySelector('.doctor_dietitian_lightbox').classList.remove('active');
                    document.querySelector('.page-overlay').classList.remove('is-visible');
                    document.body.classList.remove('overflow-hidden');
                })
            })       
        }
    }
    window.customElements.define('cus-dietitian-widget',doctorDietitian);

    function isInViewport(elem) {
        const rect = elem.getBoundingClientRect();
        return (
            rect.bottom >= 0 &&
            rect.right >= 0 &&
            rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.left <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }
    
    const stickyBar = document.querySelector('.rainforest__sticky_button_actions');
    const stickyHeaderHeight = header ? header.clientHeight : 0;
    const stickyAddToCartElements = document.querySelectorAll('[js-subscribe-processing-cart]');
    const footerSections = document.querySelectorAll('.footer__main_wrapper');
    const recentlyViewedSections = document.querySelectorAll('[section="product-recently-viewed"]');
 
    function shouldHideSticky() {
        for (const el of [...stickyAddToCartElements, ...footerSections, ...recentlyViewedSections]) {
            if (el && isInViewport(el)) return true;
        }
        return false;
    }
 
    function handleStickyScroll() {
        const scrollY = window.scrollY;
        const triggerElement = document.querySelector('[js-subscribe-processing-cart]');
        if (!triggerElement || !stickyBar) return;
        const triggerOffset = triggerElement.offsetTop;
        if (scrollY > triggerOffset) {
            if (shouldHideSticky()) {
                stickyBar.classList.remove('stickyAddToCart');
                stickyBar.style.top = '-100%';
            } else {
                stickyBar.classList.add('stickyAddToCart');
                stickyBar.style.top = stickyHeaderHeight + 'px';
            }
        } else {
            stickyBar.classList.remove('stickyAddToCart');
            stickyBar.style.top = '-100%';
        }
    }
    window.addEventListener('scroll', handleStickyScroll, { passive: true });
 
    const stickyScrollButton = document.querySelector('.rainforest__sticky_button_actions .rainforest__buttonScroll');
    const stickyScrollTarget = document.querySelector('.single_tw_o__content__form');
    if (stickyScrollButton && header && stickyScrollTarget) {
        stickyScrollButton.addEventListener('click', (e) => {
            e.preventDefault();
            const offset = stickyScrollTarget.offsetTop - header.clientHeight;
            window.scrollTo({ top: offset, behavior: 'smooth' });
        });
    }
 
    const stickyFormContainer = stickyBar;
    const stickyProductForm = document.querySelector('.single_tw_o__content__form')?.querySelector('cus-variants-single-two');
 
    if (stickyFormContainer && stickyProductForm) {
        const stickyIdMap = {};
        let stickyBoxIndexCounter = 0;
        const stickySubmitBtns = stickyFormContainer.querySelectorAll('.product-form__submit');
 
        stickySubmitBtns.forEach((submitBtn) => {
            submitBtn.addEventListener('click', (event) => {
                event.preventDefault();
 
                const Etarget = event.currentTarget;
                const sectionRoot = Etarget.closest('[data-section-type="page-lp-cyb-v"]') || document.querySelector('[data-section-type="page-lp-cyb-v"]');
                if (!sectionRoot) return;
 
                submitBtn.classList.add('loading');
                submitBtn.disabled = true;
 
                const cartDrawerSticky = document.querySelector('cart-drawer');
                if (cartDrawerSticky) cartDrawerSticky.enableLoading();
 
                let itemsToAdd = [];
                const uniqID = new Date().getTime().toString();
                const bundleID = getGuid();                
 
                const jsonScript = sectionRoot.querySelector('cus-variants-single-two .bundle-data-json');
                let bundleJson = {};
                try {
                    bundleJson = jsonScript ? JSON.parse(jsonScript.textContent) : {};
                } catch (err) {
                    console.error('[cyb-2x2] bundle-data-json parse error, sticky add-to-cart abort:', err);
                }
 
                const selectedBase = sectionRoot.querySelector('input[name="base__option"]:checked');
                let groupKey = selectedBase ? selectedBase.value : null;
 
                if (groupKey && !bundleJson[groupKey]) {
                    const allBaseRadios = Array.from(sectionRoot.querySelectorAll('input[name="base__option"]'));
                    const index = allBaseRadios.indexOf(selectedBase);
                    const fallbackKey = 'bundle_group_' + index;
                    groupKey = fallbackKey;
                }
 
                const data = groupKey ? bundleJson[groupKey] : null;
 
                if (data && data.ids) {
                    let dynamicBoxID = data.dynbox,
                        dynamicBoxIndex = 0,
                        lineQty = data.custom_quantity,
                        servingInCart = data.custom_servings,
                        customImage = data.custom_image,
                        customProductTitle = data.product_title || 'Custom Care Kit';
 
                    if (bundleID && bundleID.toString().trim() !== '') {
                        const trimmedBundleID = bundleID.toString().trim();
                        if (stickyIdMap[trimmedBundleID] === undefined) {
                            stickyIdMap[trimmedBundleID] = stickyBoxIndexCounter;
                            stickyBoxIndexCounter++;
                        }
                        dynamicBoxIndex = stickyIdMap[trimmedBundleID];
                    }
 
                    const idArray = typeof data.ids === 'string' ? data.ids.split(',') : (data.ids || []).slice();
                    const planArray = typeof data.plans === 'string' ? data.plans.split(',') : (data.plans || []).slice();
                    const qtyArray = typeof data.qtys === 'string' ? data.qtys.split(',') : (data.qtys || []).slice();
 
                    sectionRoot.querySelectorAll('[js-unlock-gifts-option]').forEach((giftWrapper) => {
                        const giftOuter = giftWrapper.querySelector('[js-button-confiq-outer]');
                        if (!giftOuter || !giftOuter.classList.contains('active')) return;

                        const giftVariantId = giftWrapper.dataset.variantId;
                        if (!giftVariantId || giftVariantId.toString().trim() === '') {
                            return;
                        }

                        const giftQtyInput = giftWrapper.querySelector('[js-button-confiq-input]');
                        const giftQtyRaw = giftQtyInput ? parseInt(giftQtyInput.textContent, 10) : 1;
                        const giftQty = Number.isFinite(giftQtyRaw) && giftQtyRaw > 0 ? giftQtyRaw : 1;

                        for (let i = 0; i < giftQty; i++) {
                            idArray.push(giftVariantId.toString().trim());
                            planArray.push(giftWrapper.dataset.sellingPlanId || '');
                            qtyArray.push('1');
                        }
                    });
 
                    const customQuantityGroup = qtyArray.join(',');
 
                    const mainProperties = {
                        _dynamicBoxId: dynamicBoxID,
                        _dynamicBoxIndex: dynamicBoxIndex,
                        _original_qty: lineQty,
                        _bundle_id: bundleID,
                        _is_byob_child: "true",
                        _is_onetime:"false",
                        _custom_image: customImage,
                        _custom_product_title: customProductTitle
                    };
 
                    itemsToAdd = idArray.map((id, index) => {
                        const itemBaseQty = parseInt(qtyArray[index]) || 1;
                        const itemProperties = {
                            ...mainProperties,
                            _uniq_id_lookup:uniqID
                        };
                        const item = {
                            id: id.toString().trim(),
                            quantity: itemBaseQty,
                            properties: itemProperties
                        };
 
                        const safePlanId = toSafeSellingPlanId(planArray[index]);
                        if (safePlanId !== null) {
                            item.selling_plan = safePlanId;
                        }
                        return item;
                    });
                }
 
                if (!itemsToAdd.length) {
                    submitBtn.classList.remove('loading');
                    submitBtn.disabled = false;
                    if (cartDrawerSticky) cartDrawerSticky.disableLoading();
                    return;
                }
 
                const productShouldBe = {
                    items: itemsToAdd,
                    sections: cartDrawerSticky?.getSectionsToRender()?.map((section) => section.section) || [],
                    sections_url: window.location.pathname
                };
 
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify(productShouldBe),
                    credentials: 'same-origin'
                })
                .then(async (response) => {
                    const data = await response.json();
                    if (!response.ok) {
                        console.error('Shopify Cart Error Response:', data);
                        throw new Error(data.description || data.message || 'Failed to add items to cart (409 Conflict)');
                    }
                    return data;
                })
                .then((parsedState) => {
                    cartDrawerSticky?.renderContent(parsedState.sections);
                })
                .catch((e) => console.error(e))
                .finally(() => {
                    cartDrawerSticky?.disableLoading();
                    cartDrawerSticky?.open();
                    document.querySelector('.cart_drawers__cross')?.setAttribute('role', 'button');
                    document.querySelector('.cart_drawers__cross')?.setAttribute('tabindex', '0');
                    submitBtn.classList.remove('loading');
                    submitBtn.disabled = false;
                });
            });
        });
    }   

    if( document?.querySelectorAll('[js-widget-overview]').length > 0 ){
        document?.querySelectorAll('[js-widget-overview]').forEach((el)=>{
            el.addEventListener('click', (target) => {
                target.preventDefault();
                const offsetRvw = document?.querySelector('.custom__product__widget').offsetTop - header.clientHeight - stickyFormContainer.clientHeight;
                window.scrollTo({
                top: offsetRvw,
                behavior: 'smooth'
                });
            })
        })
    }  

    if (document.querySelectorAll('.table__standards__chart__brief_swp.swiper').length > 0) {
        document.querySelectorAll('.table__standards__chart__brief_swp.swiper').forEach((swiperinitilize, index) => {
            new Swiper(swiperinitilize, {
                slidesPerView: 'auto',
                breakpoints: {
                    0: { spaceBetween: 8 },
                    750: { spaceBetween: 0 }
                },
                pagination: { el: `.swiper-pagination.pagination_table_chart`, clickable: true },
                navigation: { nextEl: `.swiper-button-next.next_table_chart`, prevEl: `.swiper-button-prev.prev_table_chart` }
            });
        });
    }    

    const graph__card = document.getElementById("animated__graphs__card");
    if(graph__card){
        const observerOptions = {
            root: null,
            threshold: 0.3
        };
        const observer = new IntersectionObserver((entries, observerInstance) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    graph__card.classList.add("in-view");
                    observerInstance.unobserve(entry.target);
                }
            });
        }, observerOptions);
        observer.observe(graph__card);    
    }

})